import React from 'react';

import { Stack } from '@mantine/core';
import ImageUploader from 'components/ImageUploader';

import StaffAccountForm from './components/StaffAccountForm';

const StaffAccountDetails = (): JSX.Element => {
  return (
    <Stack>
      <ImageUploader />
      <StaffAccountForm />
    </Stack>
  );
};

export default StaffAccountDetails;
